/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMarketScreenData} from '../api'

 export const useQueryGetMarketScreenData = createReactQueryHook('getMarketScreenData', getMarketScreenData)
